<div class="card border-1 rounded-5 mb-3" data-bs-toggle="modal" data-bs-target="#document_approval_modal">
  <div class="card-body p-2">
    <div class="feed-composer-row d-flex align-items-center gap-2">
      <button type="button" class="feed-composer-prompt flex-grow-1 text-xxs" aria-label="Create document approval">
        <span>Get your document approved ...</span>
      </button>
      <span class="file-action-btn" aria-hidden="true">
        <i class="bi bi-file-earmark-check-fill"></i>
      </span>
    </div>
  </div>
</div>

<div class="modal fade" id="document_approval_modal" tabindex="-1" aria-labelledby="documentApprovalModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header position-relative justify-content-between">
        <div>
          <p class="modal-title fw-bold" id="documentApprovalModalLabel">Document Approval</p>
          <p class="text-xs text-muted mb-0">Send a document or media file to reviewers for approval.</p>
        </div>
        <button
          type="button"
          class="btn-close create-approval-close position-absolute end-0 top-50 translate-middle-y me-3"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>
      <form @submit.prevent="createDocumentApproval" class="create-approval-form">
        <div class="modal-body modal-body-scroll create-approval-body">
          <div class="create-approval-section">
            <label for="create_document_name" class="form-label create-approval-label">Document Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control create-approval-input text-xs" id="create_document_name" placeholder="Enter document name" v-model="document_name">
            <p v-if="errors.document_name" class="text-danger text-xs">{{ errors.document_name }}</p>
          </div>

          <div class="create-approval-section">
            <div class="flex-grow-1">
              <label for="reviewer" class="form-label create-approval-label">
                Assign reviewers:
                <span class="text-danger">*</span>
              </label>

              <multiselect
                v-model="tempSelectedReviewer"
                :options="reviewers"
                :searchable="true"
                :internal-search="true"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="false"
                placeholder="Search reviewers"
                label="full_name"
                track-by="portal_access_id"
                class="create-approval-reviewers text-xs fw-500"
              >
                <template #option="{ option }">
                  <span v-if="option.user">
                    {{ option.user.first_name }} {{ option.user.last_name }}
                  </span>
                  <span v-else class="text-muted">Member</span>
                </template>
                <template #selection="{ values }">
                  <span
                    v-for="(reviewer, index) in values"
                    :key="index"
                    class="create-approval-reviewer-badge"
                  >
                    <span v-if="reviewer.user">
                      {{ reviewer.user.first_name }} {{ reviewer.user.last_name }}
                    </span>
                    <span v-else>
                      Member
                    </span>
                  </span>
                </template>
              </multiselect>

              <p v-if="errors.reviewer" class="text-danger text-xs">{{ errors.reviewer }}</p>
            </div>
          </div>

          <div class="create-approval-section">
            <div class="textarea-container">
              <label class="form-label create-approval-label">Description</label>
              <QuillEditor
                theme="snow"
                v-model="document_description"
                ref="createQuillDocumentEditorRef"
                class="quill-editor create-approval-editor"
                placeholder="Enter your description here..."
                toolbar="full"
              />
            </div>
          </div>

          <div class="create-approval-section">
            <div class="file-upload flex-grow-1 d-flex flex-column align-items-center">
              <div v-if="create_previews.length" class="d-flex flex-wrap gap-3 mb-3 px-1 w-100">
                <div v-for="(preview, index) in create_previews" :key="index" class="preview-item position-relative mb-2">
                  <img v-if="preview.type === 'image'" :src="preview.src" class="preview-image rounded-3 border" />

                  <div v-else-if="preview.type === 'video'" class="position-relative w-100 h-100">
                    <video class="preview-video rounded border">
                      <source :src="preview.src" />
                    </video>
                    <i class="bi bi-play-circle-fill position-absolute top-50 start-50 translate-middle text-white fs-3 opacity-75"></i>
                  </div>

                  <div v-else class="preview-item rounded-3 border bg-light d-flex flex-column align-items-center justify-content-center text-center p-1">
                    <i v-if="preview.name.endsWith('.pdf')" class="bi bi-file-earmark-pdf-fill text-danger fs-2"></i>
                    <i v-else-if="preview.name.endsWith('.doc') || preview.name.endsWith('.docx')" class="bi bi-file-earmark-word-fill text-primary fs-2"></i>
                    <i v-else-if="preview.name.endsWith('.xls') || preview.name.endsWith('.xlsx')" class="bi bi-file-earmark-excel-fill text-success fs-2"></i>
                    <i v-else class="bi bi-file-earmark-text-fill text-secondary fs-2"></i>

                    <span class="text-xxs text-truncate w-100 px-1">{{ preview.name }}</span>
                  </div>

                  <button type="button" class="btn btn-sm btn-danger fw-bold position-absolute top-0 end-0 fs-6 px-2 py-0" @click="removeApprovalFile(index)">
                    &times;
                  </button>
                </div>
              </div>

              <div
                class="drop-zone-stable d-flex align-items-center justify-content-center pointer border-2 rounded p-3 text-center transition-all position-relative w-100"
                :class="create_isDragging ? 'border-primary bg-primary-subtle' : 'border-dashed'"
                @dragover.prevent="create_isDragging = true"
                @dragenter.prevent="create_isDragging = true"
                @dragleave.prevent="create_isDragging = false"
                @drop.prevent="handleApprovalDrop"
                @click="$refs.approvalFileInput.click()"
              >
                <div class="d-flex align-items-center justify-content-center gap-2 h-100">
                  <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
                  <span class="fw-bold text-black text-sm">Drag & Drop media here or click</span>
                </div>

                <input type="file" ref="approvalFileInput" id="approvalFileInput" class="file-input d-none" multiple @change="handleApprovalFileUpload" />
              </div>

              <div v-if="fileError" class="text-xxs text-danger fst-italic mt-1">{{ fileError }}</div>
              <p v-if="errors.upload_media" class="text-danger text-xxs mt-1">{{ errors.upload_media }}</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xs rounded px-4">Submit for Approval</button>
        </div>
      </form>
    </div>
  </div>
</div>
